<ui-app-layout
  variant="portal"
  [showMenubar]="false"
  [logoSrc]="logoSrc()"
  [logoAlt]="logoAlt()"
  [navTitle]="navTitle()"
  [mobileNavTitle]="mobileNavTitle()"
  [showTitleBar]="showTitleBar()"
  [titleBarMode]="titleBarMode()"
  [title]="title()"
  [breadcrumbItems]="breadcrumbItems()"
  [breadcrumbHome]="breadcrumbHome()"
  [breadcrumbAriaLabel]="breadcrumbAriaLabel()"
  [mainLabel]="mainLabel()"
  [userAvatarLabel]="userAvatarLabel()"
  [messageCount]="resolvedMessageCount()"
  [showMessages]="resolvedShowMessages()"
  [notificationCount]="resolvedNotificationCount()"
  [notificationItems]="resolvedNotificationItems()"
  [profileUserName]="profileUserName()"
  [profileUserRole]="profileUserRole()"
  [profileUserEmail]="profileUserEmail()"
  [sidebarItems]="sidebarItems()"
  [sidebarSelectedValue]="sidebarSelectedValue()"
  [sidebarCollapsed]="sidebarCollapsed()"
  [sidebarAriaLabel]="sidebarAriaLabel()"
  [bottomNavItems]="bottomNavItems()"
  [bottomNavAriaLabel]="bottomNavAriaLabel()"
  (sidebarItemSelect)="sidebarItemSelect.emit($event)"
  (sidebarToggle)="sidebarToggle.emit()"
  (logoutClick)="logoutClick.emit()"
  (profileMenuItemClick)="onProfileMenuItem($event)"
  (notificationItemSelect)="onNotificationItem($event)"
  (notificationViewAll)="onNotificationViewAll()"
>
  <ng-container ngProjectAs="[slot-title-bar-end]">
    <ng-content select="[slot-title-bar-end]" />
  </ng-container>
  <ng-content />
</ui-app-layout>
